<template lang="pug">
validation-observer.analise(ref='validation' tag='div')
  div.analise(v-if="despacho !== null")
    app-analise-header(
      v-if="despacho.processo !== null",
      :id-processo="despacho.processo.id",
      :numero-processo="despacho.processo.numeroProcesso",
      :statusProcesso="despacho.processo.status",
      :titulo-analise="tipoEmissao",
      :tipo="despacho.processo.tipo.codigo",
      :numeroProtocolo="despacho.processo.numeroProtocolo",
      :btnSolicitarInformacao="true",
      :idDespacho="despacho.id",
      :show-separate="true",
      :show-messages='true',
      :opcoesHeader="true",
      :isEmissaoCertidao="true"
    )
      template(slot="separate")
        el-card(shadow="hover").card-collapse
          app-despachos(
            v-if="dadosCadastro",
            :idProcesso="idProcesso",
            :data="dadosCadastro",
            @getDownload="getDownload",
          )
      template(slot="analise")
        div(v-if="showDocumentosConferirTitulo && !isRevisaoOuRetorno && !isRetornoComissaoIlha")
          div(v-if="showDocumentosConferirTitulo")
            el-card.shadow-card.info-cadastro-ma(v-if="tipoReurbConferencia")
              div.info-cadastro-ma__titulo Informações do cadastro
              el-row.info-cadastro-ma__dados(:gutter="16")
                el-col(:span="8")
                  span.info-cadastro-ma__label Tipo REURB:
                  span.info-cadastro-ma__valor {{ labelTipoReurb }}
                el-col(:span="8")
                  span.info-cadastro-ma__label Bem único:
                  span.info-cadastro-ma__valor {{ labelBemUnico }}
                el-col(:span="8")
                  span.info-cadastro-ma__label Tipo requerente:
                  span.info-cadastro-ma__valor {{ labelTipoRequerente }}
          app-split-pane(
            ref="meuSplit"
            :initialLeft="400"
            :minLeft="0"
            :minRight="0"
            :startRightCollapsed="true"
            storageKey="layout-sicarf"
            @close="fecharDocumento"
            style="height: 60vh"
            :closeVisible="!!documentoAberto.src || !!documentoAberto.bytes"
          )
            template(slot="left")
              app-pdf-viewer(
                v-if="bytes && !isRevisaoOuRetorno"
                :bytes = "bytes"
                height="500"
                :hideMiniPages="true"
              )
            template(slot="right")
              app-image-preview(
                v-if="documentoAberto.src"
                ref="imagePreview"
                :src="documentoAberto.src"
                @close="fecharDocumento"
              )
              app-pdf-viewer(
                v-if="documentoAberto.bytes && !documentoAberto.isImagem"
                :bytes="documentoAberto.bytes"
                height="500"
                :hideMiniPages="true"
              )
          app-divider(label="Documentos")
          el-table(
            :data="documentosValidarTitulo"
          )
            template(slot-scope="scope")
              el-table-column(label="Tipo de documento", prop="tipoDocumento")
              el-table-column(label="Nome do arquivo:", prop="nomeArquivo")
              el-table-column(label="Ações", prop="valor", width="85")
                template(slot-scope="scope")
                  div
                    app-action-button(
                      icone="eye",
                      text="Visualizar Documento",
                      fontSize="18",
                      @click="visualizarDocumento(scope.row)"
                    )
        app-pdf-viewer(
          v-if="bytes && !isRevisaoOuRetorno && !showDocumentosConferirTitulo"
          :bytes = "bytes"
        )
        div(v-if="isRevisaoOuRetorno")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label.input-text-editor(label="Despacho")
            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="despacho.textoDespacho",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}
          app-anexo(
            :id="'upload-anexo-despacho'",
            @uploadFile="uploadFile",
            :files="despacho.documentos",
            @removeFile="removeFile"
            @downloadDocumentoCadastro="downloadDocumentoCadastro",
            :tipoExibir="'ANEXO_ANALISE'"
          )
          el-card(v-if="isArquivamentoIndeferimento && !isReurbIndividual")
            app-label(
              label="Inclua a Carta de Notificação ao Interessado"
              :required="isValidateCarta !== ''"
            )
            validation-provider(:rules="isValidateCarta", v-slot="{ errors }")
              app-anexo(
                :id="'upload-carta-notificacao'"
                @uploadFile="uploadCartaNotificacao",
                :files="cartas",
                @removeFile="removeCartaNotificacao",
                :showAnexar="true"
                :errors="errors"
                @downloadDocumentoCadastro="getDownload",
                :tiposArquivosPermitidos="tiposArquivosPermitidosMapas"
                v-model="cartas"
                :showUpload="cartas.length === 0"
              )
        h4.texto-retificacao(v-if="showTextoRetificacao") {{'Houve uma retificação desse processo neste despacho, analise o título atentamente.'}}
        div.extra-margin-top(v-if="acoesRadio.length > 0 && !isCertidao")
          validation-observer.flex-around(ref='validationTitulo' tag='div')
            app-radios-tramitacao(
              :radios="acoesRadio",
              :isDecisao="isDecisao",
              @changeRadio="changeRadio",
              :radioInicial="despacho.acao",
            )
        div.flex.extra-margin-top
          div
            el-button.btn(
              type="default"
              @click="cancelar()"
            )
              i.fa.fa-ban
              | &nbsp Cancelar
          div
            el-button.btn(
              v-if="!isRevisaoOuRetorno"
              type="default"
              @click="downloadPdf()"
            )
              | Download PDF &nbsp
              i.fa.fa-download
            el-button.btn(
              v-if="!isRevisaoOuRetorno && !(isMaranhao && isReurbIndividual)"
              type="default"
              @click="editarTituloCertidao"
            )
              | Editar {{titulo}} &nbsp
              i.fa.fa-edit
            el-button.btn(
              type="success"
              @click="finalizar"
            )
              | Finalizar &nbsp
              i.fa.fa-check
</template>

<script>
import { mapActions } from 'vuex'
import FileSaver from 'file-saver'
import AppPdfViewer from '@/components/AppPDFViewer'
import acaoProcesso from '@/constants/acaoProcesso'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import axios from '@/utils/api'
import FileHelper from '@/utils/fileHelper'
import AppAnaliseHeader from './components/shared/AppAnaliseHeader'
import AppDespachos from '@/components/AppDespachos'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import AppLabel from '@/components/AppLabel'
import AppSplitPane from './components/AppSplitPane.vue'
import AppActionButton from '@/components/AppActionButton'
import AppImagePreview from '@/components/AppImagePreview'
import utils from '@/utils/utils'

const EXTENSOES_IMAGEM = /\.(jpg|jpeg|png|gif|webp|bmp)$/i

const {
  mensagemSucessoConferenciaTitulo
} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppPdfViewer,
    AppImagePreview,
    AppAnaliseHeader,
    AppDespachos,
    AppRadiosTramitacao,
    AppAnexo,
    AppEditorTexto,
    AppLabel,
    AppSplitPane,
    AppActionButton
  },

  data () {
    return {
      bytes: null,
      despacho: null,
      cartas: [],
      tipoEmissao: '',
      dadosCadastro: null,
      titulo: '',
      mensagem: '',
      hasClickFinalizar: true,
      tiposArquivosPermitidosMapas: '.png, .jpg, .jpeg, .pdf, .doc, .docx',
      isDecisao: false,
      acoesRadio: [],
      radios: [],
      mensagemAlertBox: {
        TITULO_REVISADO: 'Título conferido com sucesso!',
        ENCAMINHAR_REVISAO_PORTARIA: 'Solicitação enviada com sucesso!'
      },
      action: null,
      documentosValidarTitulo: [],
      documentoAberto: {
        bytes: null,
        src: null
      },
      tipoReurbConferencia: null
    }
  },

  mixins: [AppNotificacao],

  props: {
    idProcesso: {
      type: [String, Number]
    },
    tipo: {
      type: String,
      default: acaoProcesso.EMITIR_TITULO
    },
    numeroProcesso: {
      type: String
    }
  },

  async mounted () {
    await this.iniciaEmissao()
    this.tipoDeTitulo()
    await axios({
      method: 'get',
      url: `despacho/pdf/titulo/processo/${this.idProcesso}`,
      responseType: 'arraybuffer'
    }).then(response => {
      this.bytes = response
    })
    if (this.isMaranhao && this.isReurbIndividual) {
      this.buscarDocumentosConferirTitulo()
    }
  },

  computed: {
    isRevisaoOuRetorno () {
      return this.action?.includes('REVISAO') ||
        this.action?.includes('RETORNO') ||
        this.action?.includes('ARQUIVA') ||
        this.action?.includes('ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA') ||
        this.action?.includes('ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA_VTN')
    },
    isReurb () {
      return this.despacho?.processo?.tipo?.codigo === 'REGULARIZACAO_URBANA'
    },
    isCertidao () {
      return this.despacho?.processo?.tipo?.codigo === 'CERTIDAO_TITULO'
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.despacho?.processo?.tipo?.codigo)
    },
    isArquivamentoIndeferimento () {
      return this.despacho?.acao?.includes('ARQUIVAMENTO') && !this?.dadosCadastros?.despacho?.acao?.includes('DESARQUIVAMENTO')
    },
    isNovaPortaria () {
      return this.despacho?.tituloDespacho?.tituloProcessoDTO?.novaPortaria
    },
    isValidateCarta () {
      return this.cartas?.length === 0 ? 'required' : ''
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    showDocumentosConferirTitulo () {
      return this.isMaranhao && this.isReurbIndividual
    },
    showTextoRetificacao () {
      return this.isMaranhao && this.tipoReurbConferencia?.hasRetificacao === true
    },
    labelTipoReurb () {
      return utils.labelTipoReurb(this.tipoReurbConferencia?.tipoReurbAtual)
    },
    labelBemUnico () {
      return utils.labelBemUnico(this.tipoReurbConferencia?.bemUnico)
    },
    labelTipoRequerente () {
      return utils.labelTipoRequerente(this.tipoReurbConferencia?.tipoRequerente)
    },
    isRetornoComissaoIlha () {
      return this.action === 'ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA'
    }
  },

  methods: {
    async iniciaEmissao () {
      const response = await this.iniciaAnalise({
        idProcesso: this.idProcesso,
        tipoAcao: this.tipo
      })
      this.despacho = response.despacho
      this.dadosCadastro = response.setores
      this.cartas = response.despacho.anexosCarta
      this.radios = await this.tarefa({ processo: this.idProcesso })

      if (this.isMaranhao) {
        this.tipoReurbConferencia = await this.getTipoReurbConferencia(this.idProcesso).catch(() => ({
          tipoReurbAtual: null,
          bemUnico: null,
          tipoRequerente: null,
          hasRetificacao: false,
          hasTrocaTipoReurb: false
        }))
        this.verificaAcao(this.tipoReurbConferencia)
      } else {
        this.acoesRadio = this.isNovaPortaria ? this.radios.acoes.filter(acao => acao.valor.includes('TITULO_REVISADO')) : this.radios.acoes
      }
      if (process.env.ESTADO === 'rr') {
        this.despacho.acao = this.acoesRadio[0].valor
      }
    },
    verificaAcao (tipoReurb = { tipoReurbAtual: null, hasRetificacao: false, hasTrocaTipoReurb: false }) {
      let valoresBloqueados = []

      if (tipoReurb.hasRetificacao && tipoReurb.hasTrocaTipoReurb) {
        valoresBloqueados.push('FINALIZAR.SISTEMA.CTRU_CONFERENCIA.AUTOCOMPLETE')

        if (tipoReurb.tipoReurbAtual === 'REURB_E' && tipoReurb.hasTrocaTipoReurb) {
          valoresBloqueados.push('RETORNO.SISTEMA.ANTERIOR')
          valoresBloqueados.push('RETORNO_MANUALMENTE.SISTEMA.ANTERIOR')
        } else if (tipoReurb.tipoReurbAtual === 'REURB_S' && tipoReurb.hasTrocaTipoReurb) {
          valoresBloqueados.push('ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA_VTN')
        }
      } else {
        valoresBloqueados.push('ENCAMINHAMENTO.SISTEMA.COMISSAO_ILHA_VTN')
      }

      this.acoesRadio = this.radios.acoes.filter(
        acao => !valoresBloqueados.some(v => acao.valor.includes(v))
      )
    },
    async buscarDocumentosConferirTitulo () {
      const result = await this.getDocumentosConferirTitulo(this.idProcesso)
      if (result?.length) {
        this.documentosValidarTitulo = result.map(doc => {
          const isFoto = doc?.caminho?.includes('fotos') || false
          const isImagem = !isFoto && EXTENSOES_IMAGEM.test(doc?.nome || '')
          return {
            id: doc.id,
            tipoDocumento: doc.tipo?.descricao || doc.tipoDocumento?.descricao || '',
            nomeArquivo: this.sliceInicioFim(doc.nome),
            nome: doc.nome,
            isFoto,
            isImagem,
            caminho: doc?.caminho || null
          }
        })
      }
    },

    sliceInicioFim (str) {
      if (!str) return ''
      const inicio = str.slice(0, 20)
      const fim = str.slice(-20)
      return inicio + '...' + fim
    },

    async visualizarDocumento (documento) {
      try {
        if (documento.isFoto) {
          const response = await this.getFotosByCaminhoId({ id: documento.id, caminho: documento.caminho })
          if (response) {
            const byteArray = new Uint8Array(response)
            const blob = new Blob([byteArray], { type: 'image/jpeg' })
            this.documentoAberto.bytes = null
            this.documentoAberto.src = URL.createObjectURL(blob)
            this.$nextTick(() => this.$refs.imagePreview && this.$refs.imagePreview.showPreview())
            this.$refs.meuSplit.expandHalf()
          }
        } else {
          const file = await this.getDocumentoFile(documento)
          const arrayBuffer = await file.arrayBuffer()
          this.documentoAberto.src = null
          this.documentoAberto.bytes = new Uint8Array(arrayBuffer)
          if (documento.isImagem) {
            const mimeType = this.getMimeTypeImagem(documento.nome)
            const blob = new Blob([this.documentoAberto.bytes], { type: mimeType })
            this.documentoAberto.src = URL.createObjectURL(blob)
            this.documentoAberto.bytes = null
            this.$nextTick(() => this.$refs.imagePreview && this.$refs.imagePreview.showPreview())
          }
          this.$refs.meuSplit.expandHalf()
        }
      } catch (error) {
        this.$refs.meuSplit.expandLeftFull()
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          'Erro ao carregar documento.'
        )
      }
    },

    getMimeTypeImagem (nome) {
      if (!nome) return 'image/jpeg'
      const ext = nome.split('.').pop()?.toLowerCase()
      const mimeMap = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp', bmp: 'image/bmp' }
      return mimeMap[ext] || 'image/jpeg'
    },

    fecharDocumento () {
      this.documentoAberto = { bytes: null, src: null }
      if (this.$refs.meuSplit?.expandLeftFull) {
        this.$refs.meuSplit.expandLeftFull()
      }
    },

    setCartaNotificacaoInteressado () {
      this.cartas.forEach(carta => {
        this.despacho.documentos.push(carta)
      })
    },

    ...mapActions({
      finalizarDespacho: 'despacho/finalizar',
      iniciaAnalise: 'processo/iniciaAnalise',
      tarefa: 'processo/tarefa',
      getTipoReurbConferencia: 'processo/getTipoReurbConferencia',
      getPdfTituloByProcessoId: 'despacho/getPdfTituloByProcessoId',
      getDocumentosConferirTitulo: 'processos/getDocumentosConferirTitulo',
      getFotosByCaminhoId: 'fotos/getFotosByCaminhoId',
      getDocumentoFile: 'documentos/getDocumentoFile'
    }),

    editarTituloCertidao () {
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          despachoEdicao: this.despacho,
          idProcesso: this.idProcesso,
          tipo: acaoProcesso.CONFERENCIA_TITULO,
          urlOrigem: 'AGUARDANDO_VALIDACAO_ANALISE'
        }
      })
    },
    async finalizar () {
      if (this.isRevisaoOuRetorno) {
        const valido = await this.$refs.validation.validate()
        if (!valido) {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERROS_ANALISE)
          return
        }
        this.despacho.tipo = this.action?.includes('REVISAO') ? 'REVISAO' : 'ANALISE'
      }
      if (!this.isReurb && !this.isCertidao) {
        const valido = await this.$refs.validationTitulo.validate()
        if (!valido) {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERROS_ANALISE)
          return
        }
      }
      this.confirmBox(
        this.$messages.CONFIRM_EMISSAO_CONFERENCIA_TITULO,
        this.$messages.TITULO_WARNING,
        () => {
          if (this.hasClickFinalizar) {
            this.hasClickFinalizar = false
            if (this.isArquivamentoIndeferimento) {
              this.setCartaNotificacaoInteressado()
              this.cartas = []
            }
            this.finalizarDespacho(this.despacho)
              .then((response) => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  mensagemSucessoConferenciaTitulo(response)
                )
                this.$router.push({
                  name: 'EM_ANALISE'
                })
                this.hasClickFinalizar = true
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Erro ao conferir Título.'
                )
                this.hasClickFinalizar = true
              })
          }
        },
        () => {}
      )
    },

    downloadPdf () {
      FileHelper.saveFile(this.bytes, this.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO' ? 'minuta da certidão' : 'minuta do errata')
    },

    async getDownload (documento) {
      const file = await this.getDocumentoFile(documento)
      FileSaver.saveAs(file, documento.nome)
    },

    cancelar () {
      if (this.isEstadoMA) {
        this.confirmBox(
          `${this.$messages.CANCELA_CONFERENCIA} do(a) ${this.titulo} ?`,
          this.$messages.TITULO_WARNING,
          () => {
            this.$router.back()
          },
          () => {}
        )
      } else {
        this.confirmBox(
          `${this.$messages.CANCELA_CONFERENCIA} do(a) ${this.titulo} ?`,
          this.$messages.TITULO_WARNING,
          () => {
            this.$router.push({
              name: 'AGUARDANDO_VALIDACAO_ANALISE'
            })
          },
          () => {}
        )
      }
    },

    tipoDeTitulo () {
      switch (this.despacho.processo.tipo.codigo) {
        case 'CERTIDAO_TITULO':
          this.tipoEmissao = 'Emissão de certidão título'
          this.titulo = 'certidão título'
          this.mensagem = 'Certidão conferida com sucesso!'
          break
        case 'ONEROSO':
        case 'NAO_ONEROSO':
        case 'ONEROSO_FISICO':
        case 'NAO_ONEROSO_FISICO':
          this.tipoEmissao = 'Emissão de título'
          this.titulo = 'título'
          this.mensagem = 'Título conferido com sucesso! Processo enviado para a Assinatura da Presidência.'
          break
        case 'REGULARIZACAO_URBANA':
          this.tipoEmissao = 'Emissão de título'
          this.titulo = 'título'
          this.mensagem = 'Título conferido com sucesso!'
          break
      }
    },

    changeRadio (value) {
      this.despacho.acao = value.acao
      this.action = value.acao
      if (this.despacho.processo.tipo.codigo === 'NAO_ONEROSO' || this.despacho.processo.tipo.codigo === 'ONEROSO' || this.despacho.processo.tipo.codigo === 'TEQ' || this.despacho.processo.tipo.codigo === 'PEAEX') {
        this.getMensagemAlert()
      }
    },

    getMensagemAlert () {
      if (this.mensagemAlertBox[this.despacho.acao.split('.')[0]]) {
        this.mensagem = this.mensagemAlertBox[this.despacho.acao.split('.')[0]]
      }
    },
    onTextChange (text) {
      this.despacho.textoDespacho = text
    },

    uploadFile (file) {
      this.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => { })
    },

    uploadCartaNotificacao (file) {
      this.cartas.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 341,
          codigo: 'CARTA_NOTIFICACAO_INTERESSADO'
        }
      })
    },

    removeCartaNotificacao (documento) {
      const index = this.cartas.indexOf(
        this.cartas.find(m => m.key === documento.key)
      )
      this.cartas.splice(index, 1)
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.despacho.documentos.indexOf(this.despacho.documentos.find(a => a.id === documento.id))
        this.despacho.documentos.splice(index, 1)
      } else {
        const index = this.despacho.documentos.indexOf(this.despacho.documentos.find(a => a.key === documento.key))
        this.despacho.documentos.splice(index, 1)
      }
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    }
  }
}
</script>

<style lang="scss">
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.flex-around {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.view-document-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 999;
}

.close-doc-btn{
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 20;

  background: #f0f0f0;
  border-color: #dcdcdc;
  color: #606266;
}

.texto-retificacao {
  display: flex;
  justify-content: center;
  color: red !important;
}

.info-cadastro-ma {
  margin-bottom: 16px;

  &__titulo {
    font-weight: 600;
    margin-bottom: 12px;
    color: #303133;
  }

  &__dados {
    font-size: 14px;
  }

  &__label {
    color: #909399;
    margin-right: 6px;
  }

  &__valor {
    color: #303133;
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ConferenciaTituloCertidao.vue